/* ============================================================
   LFDL — Fréquemment achetés ensemble (FBT)
   Objectifs:
   - Toujours déterminer un variant_id (même sans changement de select)
   - Ajouter au panier sans redirection /cart
   - Gérer un état "loading" sans bloquer définitivement
   ============================================================ */
(() => {
  function formatMoney(cents, moneyFormat, currency) {
    const value = (Number(cents || 0) / 100).toFixed(2).replace(".", ",");
    // Format simple: "12,34 €"
    return currency ? `${value} ${currency}` : value;
  }

  function setButtonState(btn, state) {
    if (!btn) return;
    const baseLabel = btn.dataset.lfdlBaseLabel || btn.textContent.trim();
    if (!btn.dataset.lfdlBaseLabel) btn.dataset.lfdlBaseLabel = baseLabel;

    if (state === "loading") {
      btn.disabled = true;
      btn.classList.add("is-loading");
      btn.textContent = "Ajout en cours...";
    } else if (state === "success") {
      btn.disabled = false;
      btn.classList.remove("is-loading");
      btn.textContent = "Ajouté au panier";
      window.setTimeout(() => {
        btn.textContent = btn.dataset.lfdlBaseLabel || baseLabel;
      }, 1200);
    } else {
      btn.disabled = false;
      btn.classList.remove("is-loading");
      btn.textContent = btn.dataset.lfdlBaseLabel || baseLabel;
    }
  }

  async function addItems(items) {
    const cartNotification = document.querySelector("cart-notification");
    const sections = cartNotification
      ? cartNotification.getSectionsToRender().map((s) => s.id)
      : ["cart-icon-bubble"];

    const formData = new FormData();
    items.forEach((it, i) => {
      formData.append(`items[${i}][id]`, String(it.id));
      formData.append(`items[${i}][quantity]`, String(it.quantity || 1));
    });
    formData.append("sections", sections);
    formData.append("sections_url", window.location.pathname);

    const url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : "/cart/add";
    const res = await fetch(url, {
      method: "POST",
      headers: { "Accept": "application/json" },
      body: formData
    });

    if (!res.ok) {
      const txt = await res.text();
      throw new Error(txt || "cart/add failed");
    }
    return res.json();
  }

  async function refreshCartBubbleSoft() {
    // Best-effort: si le thème écoute un event custom, ça suffit.
    document.dispatchEvent(new CustomEvent("lfdl:cart-updated"));
    // Sinon, on tente de mettre à jour un badge classique si présent.
    try {
      const r = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
      if (!r.ok) return;
      const cart = await r.json();
      const count = Number(cart.item_count || 0);
      const nodes = document.querySelectorAll("[data-cart-count], .cart-count-bubble span, .cart-count-bubble");
      nodes.forEach((n) => {
        if (n && n.tagName === "SPAN") {
          n.textContent = String(count);
        }
      });
    } catch (_) {}
  }

function triggerCartNotification(parsedState) {
    const cartNotification = document.querySelector("cart-notification");
    if (cartNotification && parsedState && parsedState.sections && parsedState.key) {
      cartNotification.renderContents(parsedState);
      return;
    }

    // Fallback : ouvrir un drawer si présent
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.open === "function") {
      cartDrawer.open();
      return;
    }
    if (cartDrawer) {
      cartDrawer.classList.add("active");
    }
  }

  function initContainer(root) {
    const items = Array.from(root.querySelectorAll("[data-fbt-item]"));
    const totalNode = root.querySelector("[data-fbt-total]");
    const addButton = root.querySelector("[data-fbt-add]");
    const currency = root.dataset.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || "€";
    const moneyFormat = root.dataset.moneyFormat || "";

    function syncItemFromSelect(item) {
      const select = item.querySelector("[data-fbt-variant]");
      if (!select) return;
      const option = select.options[select.selectedIndex];
      if (!option) return;
      item.dataset.variantId = option.value;
      item.dataset.variantPrice = option.dataset.price || item.dataset.variantPrice || "0";
      const priceNode = item.querySelector("[data-fbt-item-price]");
      if (priceNode) {
        priceNode.textContent = formatMoney(item.dataset.variantPrice, moneyFormat, currency);
      }
    }

    function updateTotal() {
      let total = 0;
      items.forEach((item) => {
        const checkbox = item.querySelector("[data-fbt-checkbox]");
        if (checkbox && !checkbox.checked) return;
        const price = Number(item.dataset.variantPrice || "0");
        total += price;
      });
      if (totalNode) totalNode.textContent = formatMoney(total, moneyFormat, currency);
    }

    // Init + listeners
    items.forEach((item) => {
      // Important: initialisation même sans interaction utilisateur
      syncItemFromSelect(item);

      const select = item.querySelector("[data-fbt-variant]");
      if (select) {
        select.addEventListener("change", () => {
          syncItemFromSelect(item);
          updateTotal();
        });
      }
      const checkbox = item.querySelector("[data-fbt-checkbox]");
      if (checkbox && !checkbox.disabled) {
        checkbox.addEventListener("change", updateTotal);
      }
    });

    updateTotal();

    if (addButton) {
      addButton.addEventListener("click", async (e) => {
        e.preventDefault();

        const itemsToAdd = [];
        items.forEach((item) => {
          const checkbox = item.querySelector("[data-fbt-checkbox]");
          if (checkbox && !checkbox.checked) return;

          // On re-synchronise au cas où
          syncItemFromSelect(item);

          const id = Number(item.dataset.variantId || 0);
          const qty = Number(item.dataset.qty || 1);
          if (id > 0) itemsToAdd.push({ id, quantity: qty });
        });

        if (!itemsToAdd.length) return;

        setButtonState(addButton, "loading");
        try {
          const parsedState = await addItems(itemsToAdd);
          await refreshCartBubbleSoft();
          triggerCartNotification(parsedState);
          setButtonState(addButton, "success");
        } catch (err) {
          console.error("[LFDL FBT] add failed", err);
          setButtonState(addButton, "idle");
          // fallback: au moins ne pas bloquer l'UI
          alert("Impossible d'ajouter au panier. Réessayez.");
        }
      });
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-fbt-section]").forEach(initContainer);
  });
})();
